export const buildSignInUrl = (loginUrl: string, continueUrl: string) => {
  const signInUrl = new URL(loginUrl)
  signInUrl.searchParams.set('continue', continueUrl)

  return signInUrl.toString()
}
